import React from 'react';

const ChatSuggestions = ({ suggestions, handleSuggestionClick }) => {
  return (
    <div className="flex flex-nowrap overflow-x-auto sm:flex-wrap sm:justify-center gap-2 sm:gap-3 mb-4 w-full min-w-0 max-w-[800px] p-1.5 sm:px-2 scrollbar-hide">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => handleSuggestionClick(suggestion)}
          className="flex-shrink-0 bg-white border border-gray-100 rounded-2xl px-3 py-2.5 sm:px-4 sm:py-3 text-[0.7rem] sm:text-[0.82rem] font-medium text-gray-600 cursor-pointer whitespace-nowrap transition-all duration-200 ease-in-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
          style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'var(--color-primary)';
            e.currentTarget.style.color = 'var(--color-primary)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = '#f3f4f6';
            e.currentTarget.style.color = '#4b5563';
          }}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default ChatSuggestions;
